import React from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '../../../components/ui/Button';

const QuickActions = () => {
  const navigate = useNavigate();

  const actions = [
    {
      label: 'Buy Crypto',
      icon: 'ShoppingCart',
      variant: 'default',
      onClick: () => navigate('/trading-interface')
    },
    {
      label: 'Sell Crypto',
      icon: 'TrendingDown',
      variant: 'outline',
      onClick: () => navigate('/trading-interface')
    },
    {
      label: 'Add Funds',
      icon: 'Plus',
      variant: 'secondary',
      onClick: () => navigate('/funding-portal')
    },
    {
      label: 'Withdraw',
      icon: 'ArrowDownToLine',
      variant: 'outline',
      onClick: () => navigate('/funding-portal')
    }
  ];

  return (
    <div className="bg-card rounded-xl p-6 md:p-8 shadow-md border border-border">
      <h3 className="text-xl md:text-2xl font-bold text-foreground mb-6">Quick Actions</h3>
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 md:gap-4">
        {actions?.map((action) => (
          <Button
            key={action?.label}
            variant={action?.variant}
            iconName={action?.icon}
            iconPosition="left"
            onClick={action?.onClick}
            fullWidth
            className="h-auto py-4 md:py-5 flex-col gap-2"
          >
            <span className="text-sm md:text-base">{action?.label}</span>
          </Button>
        ))}
      </div>
    </div>
  );
};

export default QuickActions;